import { Checkbox, DataView, Widget } from '@creditsights/styleguide-web';
import { ReactElement, MouseEvent } from 'react';
import { isEmpty } from 'lodash';
import { useFetchPaginatedArticles } from '../../../../hooks/articles';
import { ContentTypeTag, FeedType, Filters } from '../../../../models';
import { useBreakpoint } from '../../../../hooks/common';
import { ArticleTableRow } from '../../../../models/ArticleTableRow';
import { CONTENT_TYPE_FILTER_URL_KEY } from '../../../FiltersBar/FiltersBar.logic';
import NoResults from '../../../NoResults';
import { getExpandedViewConfig } from '../../common/viewConfigs';

interface ResearchProps {
  watchListId: string;
  openArticlePreviewOnClick: boolean;
  setOpenArticlePreviewOnClick: (value: boolean) => void;
  onPreviewableArticleClick: (article: ArticleTableRow, event: MouseEvent<HTMLElement>) => void;
  isPreviewable: boolean;
}

const DEFAULT_TAKE: number = 10;
const DEFAULT_PAGE: number = 1;
const getKey = (article: ArticleTableRow) => article.id;

const Research = ({
  watchListId,
  openArticlePreviewOnClick,
  setOpenArticlePreviewOnClick,
  onPreviewableArticleClick,
  isPreviewable,
}: ResearchProps): ReactElement => {
  const { isTabletPortrait, isDesktop } = useBreakpoint();
  const filters: Filters = {
    tags: {
      [CONTENT_TYPE_FILTER_URL_KEY]: [ContentTypeTag.Research],
    },
    watchlistId: watchListId,
  };
  const { data, isFetching, isError, refetch } = useFetchPaginatedArticles(
    FeedType.My,
    DEFAULT_TAKE,
    DEFAULT_PAGE,
    filters,
    undefined
  );

  const renderResearch = () => {
    if (!data || isEmpty(data)) {
      return <NoResults />;
    }
    const config = getExpandedViewConfig(isTabletPortrait, onPreviewableArticleClick, isPreviewable, false);
    return <DataView data={data} config={config} getKey={getKey} expanded />;
  };

  return (
    <Widget
      headerTitle="Research (Latest 10)"
      isLoading={isFetching}
      isError={isError}
      onRetryAfterErrorClick={refetch}
      wrapFirstLine
      firstLine={
        isDesktop ? (
          <Checkbox
            className="article-preview-toggle"
            dataTestId="article-preview-toggle"
            onClick={() => setOpenArticlePreviewOnClick(!openArticlePreviewOnClick)}
            checked={openArticlePreviewOnClick}
            toggle
            label="Show article previews"
            aria-label="Show article previews"
          />
        ) : undefined
      }
      dataTestId="research-widget"
    >
      {renderResearch()}
    </Widget>
  );
};
export default Research;
